// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"4":"807ead23","60":"6734d3fb","949":"98521b4a"}[chunkId] + ".css";
};